import { useEffect } from 'react';
import {
  isRuntimeDevMode,
  toggleRuntimeDevMode,
} from '../config/devFlags';

/**
 * Registers a Cmd+Option+Shift+D (Mac) / Ctrl+Alt+Shift+D (Windows) keyboard shortcut
 * that toggles all dev-mode flags at runtime.
 *
 * Three-modifier combo avoids conflicts with browser-reserved shortcuts (e.g.
 * Cmd+Shift+D opens bookmark-all-tabs in Chrome).
 *
 * Always registered — the 3-modifier combo is impossible to trigger accidentally,
 * and the backend dev-skip endpoint is separately gated by server-side flags.
 */
export function useDevModeShortcut(): void {
  useEffect(() => {
    const onKeyDown = (e: KeyboardEvent) => {
      const isMac = navigator.platform.toUpperCase().includes('MAC');
      const modKey = isMac ? e.metaKey : e.ctrlKey;
      // Use e.code (physical key) not e.key — on Mac, Option+D produces '∂' not 'd'
      if (modKey && e.shiftKey && e.altKey && e.code === 'KeyD') {
        e.preventDefault();
        const next = !isRuntimeDevMode();
        // Brief console message before reload so devs know what happened
        console.info(`[Baba] Dev mode ${next ? 'ON' : 'OFF'} — reloading`);
        toggleRuntimeDevMode();
      }
    };

    window.addEventListener('keydown', onKeyDown);
    return () => window.removeEventListener('keydown', onKeyDown);
  }, []);
}
